import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionsLogin } from '../../actions';
import { ComponentsLoginForm } from "../../components/Login/Form";
import { ServiceLogin } from "../../service/Login";
import { Messages } from 'primereact/messages';
import { ServiceMessage } from "../../service/Message";
import { ComponentsAppSplash } from "../../components/App/Splash";
import { ScreensLGPDForm } from '../LGPD/Form';
import { HistoricoAceiteLGPD } from '../../service/HistoricoAceiteLGPD';
import { ServiceConfig } from './../../service/Config';
import { ServiceApi } from './../../service/Api';
class ScreensLoginForm extends Component {

    constructor() {

        super();

        this.state = {
            splash: false,
            isLicense: false,
            objLGPD: { Usuario: '', Exibir: false, Perfil: "" },
            logoutMessage: null,
            erroLogin: false,

            //Estados 2FA
            autenticacaoDoisFatores: false,
            emailCadastro: "",
            msgEmailNaoCadastrado: "",
            codigoAcesso: "",
            dadosUsuario: null
        };

        this.aceiteLGPD = localStorage.getItem('AceiteLGPD') === 'SIM';

        this.serviceLogin = new ServiceLogin();
        this.serviceConfig = new ServiceConfig();
        this.historicoAceiteLGPD = new HistoricoAceiteLGPD();

        // Acesso via Token pela URL
        const acesso_token = window.location.href.split("token=");
        if (acesso_token[1]) {
            const token = acesso_token[1].replace("#/", "").trim();
            this.handleExecuteToken(token);
        }
    }

    componentDidMount() {
        // Checa aceite LGPD se ainda tiver uma sessão
        if (sessionStorage.getItem('auth'))
            this.historicoAceiteLGPD.ChecarAceiteLGPD();

        const logoutMsg = sessionStorage.getItem('logoutMessage');
        console.log('Mensagem recebida no login:', logoutMsg);

        if (logoutMsg) {
            this.setState({ logoutMessage: logoutMsg });
            sessionStorage.removeItem('logoutMessage');
        }
    }

    getDadosUsuario(data, perfil) {
        return {
            Nome: data.Nome,
            AcessoDTO: {
                UsuarioId: data.Id,
                Perfil: perfil,
                DadosAcesso: ''
            }
        };
    }

    async getConfig(e) {
        try {
            const response = await this.serviceConfig.GetConfig();
            const config = {};
            const objConfig = {};

            response.map(obj => {
                config[obj.Key] = { Value: obj.Value };
            });

            if (config['NOME_BOTAO_IMPRIMIR_PORTAL'])
                objConfig.NomeBotaoImprimirPortal = config['NOME_BOTAO_IMPRIMIR_PORTAL'].Value;

            if (config['23'])
                objConfig['23'] = JSON.parse(config['23'].Value);

            if (config['VIEWER_ACCESS_KEY']) {
                sessionStorage.setItem('viewerAccessKey', config['VIEWER_ACCESS_KEY'].Value);
            }

            sessionStorage.setItem('config', JSON.stringify(objConfig));

        }
        catch (err) {
            console.error("Erro inesperado no getConfig:", err);
            this.setState({ splash: false });
            ServiceMessage.warn("Erro inesperado durante a autenticação.");
        }
    }

    async handleLoginSequencial(e, cnpjCliente) {
        const usuario = e.usuario;
        const senha = e.senha;

        const perfis = [
            { tipo: 'Paciente', metodo: (u, s) => this.serviceLogin.loginPaciente(u, s, e.codigoAcesso || "", e.reenviarCodigo !== undefined ? e.reenviarCodigo : false, cnpjCliente) },
            { tipo: 'Medico', metodo: this.serviceLogin.login.bind(this.serviceLogin) },
            { tipo: 'Convênio', metodo: this.serviceLogin.loginConvenio.bind(this.serviceLogin) }
        ];

        for (const perfil of perfis) {
            console.log(` Tentando login como ${perfil.tipo}`);
            try {
                const response = await perfil.metodo(usuario, senha);

                // checa 2FA
                if (response.AutenticacaoDoisFatores) {
                    if (!response.EmailCadastro || response.EmailCadastro.trim() === "") {
                        this.serviceLogin.msgEmailNaoCadastrado()
                            .then(msg => {
                                return this.setState({
                                    autenticacaoDoisFatores: true,
                                    emailCadastro: response.EmailCadastro,
                                    msgEmailNaoCadastrado: msg,
                                    codigoAcesso: response.CodigoAcesso,
                                    dadosUsuario: { response, perfil: perfil.tipo },
                                    splash: false
                                })
                            })
                    }
                    return this.setState({
                        autenticacaoDoisFatores: true,
                        emailCadastro: response.EmailCadastro,
                        msgEmailNaoCadastrado: response.MsgEmailNaoCadastrado,
                        codigoAcesso: response.CodigoAcesso,
                        dadosUsuario: { response, perfil: perfil.tipo },
                        splash: false // desliga pq vai esperar código
                    });
                }

                // fluxo normal=
                const usuarioFormatado = this.getDadosUsuario(response, perfil.tipo);
                await this.getConfig(e);

                if (this.aceiteLGPD === false) {
                    this.setState({
                        objLGPD: { Usuario: usuarioFormatado, Exibir: true, Perfil: perfil.tipo },
                        splash: false // espera aceite antes de ir pro portal
                    });
                    return;
                }

                sessionStorage.setItem("perfil", perfil.tipo);
                this.finalizarLogin(perfil.tipo);
                return;
            } catch (err) {

                const msg = (err && err.response && (err.response.data.Message || err.response.data.message || err.response.data)) || err.message;

                if (msg && String(msg).includes('Código de acesso incorreto')) {
                    ServiceMessage.warn('Código de acesso incorreto.');
                    this.setState({ autenticacaoDoisFatores: true, splash: false});
                    return;
                }

                console.warn(` Falhou como ${perfil.tipo}`, err);
            }
        }

        this.setState({ erroLogin: true, splash: false });
    }



    handleExecuteNaoRecebiCodigo(e) {
        this.serviceLogin.msgEmailNaoCadastrado()
            .then(response => {
                return this.setState({
                    msgEmailNaoCadastrado: response
                });
            })
    }


    async handleExecuteToken(token) {
        this.setState({ splash: true });
        this.serviceLogin.acessoToken(token)
            .then(response => {
                if (this.aceiteLGPD === false)
                    return this.setState({ objLGPD: { Usuario: this.getDadosUsuario(response), Exibir: true, Perfil: 'Paciente' } }
                );

                this.getConfig({});

                window.location = "#/portal";
            })
            .catch(err => {
                ServiceMessage.warn('Acesso indisponível.');
            })
            .finally(() => { this.setState({ splash: false }); });
    }



    async handleExecute(e) {
        console.log("Entrou no handleExecute com dados:", e);

        if (e.usuario === "") {
            this.setState({ erroLogin: true, erroCampo: 'usuario' });
            return;
        }

        if (e.senha === "") {
            this.setState({ erroLogin: true, erroCampo: 'senha' });
            return;
        }

        this.setState({ erroLogin: false, erroCampo: null });

        ServiceApi._getCnpj().then(cnpjCliente => {
            this.handleLoginSequencial(e, cnpjCliente);
        });
    }


    finalizarLogin(perfil) {
        const isLicense = JSON.parse(sessionStorage.getItem("config"));
        if (isLicense['23']) {
            this.setState({ isLicense: isLicense });
        } else {
            window.location = "#/portal";
        }
    }

    render() {

        return (
            <div>

                {this.state.logoutMessage && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999
                    }}>
                        <div style={{
                            backgroundColor: '#fff',
                            padding: '30px 40px',
                            borderRadius: '8px',
                            boxShadow: '0 0 20px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                            maxWidth: '90%',
                            width: '400px'
                        }}>
                            <p style={{ fontSize: '16px', marginBottom: '20px' }}>{this.state.logoutMessage}</p>
                            <button
                                style={{
                                    padding: '10px 20px',
                                    borderRadius: '4px',
                                    backgroundColor: '#007ad9',
                                    color: '#fff',
                                    border: 'none',
                                    cursor: 'pointer'
                                }}
                                onClick={() => this.setState({ logoutMessage: null })}
                            >
                                Fechar
                            </button>
                        </div>
                    </div>
                )}

                <ScreensLGPDForm objLGPD={this.state.objLGPD} />
                <ComponentsAppSplash visible={this.state.splash} />
                <Messages ref={(el) => this.messages = el} />
                <ComponentsLoginForm
                    onExecute={this.handleExecute.bind(this)}
                    onExecuteNaoRecebiCodigo={this.handleExecuteNaoRecebiCodigo.bind(this)}
                    onResetErroLogin={() => this.setState({ erroLogin: false })}
                    erroLogin={this.state.erroLogin}
                    exibirTipo={true}
                    isLicense={this.state.isLicense}
                    perfil=""

                    //Props extras para 2FA
                    autenticacaoDoisFatores={this.state.autenticacaoDoisFatores}
                    emailCadastro={this.state.emailCadastro}
                    msgEmailNaoCadastrado={this.state.msgEmailNaoCadastrado}
                    codigoAcesso={this.state.codigoAcesso}
                />

            </div>
        );

    }
}

const mapDispatchToProps = dispatch =>
    bindActionCreators({ actionsLogin }, dispatch);

const mapStateToProps = store => ({
    login: store.stateLogin.login,
});

export default connect(mapStateToProps, mapDispatchToProps)(ScreensLoginForm);